module.exports = __webpack_public_path__ + "static/media/cartoon_yaoxin_hui.b3d41b1c.png";